export function GetMockMilestoneNoteList() {
  return [
    {
      id: 9,
      caseMilestoneId: 15,
      addedByUserId: 45,
      note: "Went to voicemail, i will retry them shortly. (10:30am)",
      dateAdded: "2022-02-02T10:56:23.6765598",
      dateUpdated: "0001-01-01T00:00:00",
      isDeleted: 0,
      dateDeleted: "0001-01-01T00:00:00",
    },
    {
      id: 16,
      caseMilestoneId: 15,
      addedByUserId: 45,
      note: "Went to voicemail again",
      dateAdded: "2022-02-03T16:28:56.4627896",
      dateUpdated: "0001-01-01T00:00:00",
      isDeleted: 0,
      dateDeleted: "0001-01-01T00:00:00",
    },
    {
      id: 17,
      caseMilestoneId: 15,
      addedByUserId: 45,
      note: "04/02/22 @ 9:32 - Went to voicemail",
      dateAdded: "2022-02-04T09:32:33.6567216",
      dateUpdated: "0001-01-01T00:00:00",
      isDeleted: 0,
      dateDeleted: "0001-01-01T00:00:00",
    },
    {
      id: 24,
      caseMilestoneId: 15,
      addedByUserId: 45,
      note: "Went to voicemail again, i have tried to make contact 4 times now so i will see if he comes back to me.",
      dateAdded: "2022-02-07T10:24:19.8442543",
      dateUpdated: "0001-01-01T00:00:00",
      isDeleted: 0,
      dateDeleted: "0001-01-01T00:00:00",
    },
  ];
}
